var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaffRooms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 27,
    viewBox: "0 0 47 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53162 21.4302V13.688H46.3017V21.4302H5.53162Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.521 11.9967C5.521 11.3243 5.521 10.673 5.521 10.0427C5.55859 9.76673 5.6896 9.51194 5.89221 9.3208C6.09483 9.12965 6.35681 9.01369 6.63453 8.99223H44.6943C45.0618 8.98291 45.4249 9.07369 45.7448 9.25485C46.0235 9.46732 46.2082 9.78016 46.2596 10.1268C46.3019 10.7599 46.3019 11.3951 46.2596 12.0282L5.521 11.9967Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85081 21.4511H0.772827V0.251953H3.85081V21.4511Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.392 23.1109C43.2659 24.0983 43.1609 25.0543 43.0348 26.0103C43.0149 26.0672 42.98 26.1178 42.9338 26.1566C42.8876 26.1954 42.8317 26.221 42.7722 26.2309C42.4255 26.2309 42.0684 26.2309 41.7217 26.2309L41.333 23.0793L43.392 23.1109Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22058 23.1003H5.32159L4.94341 26.2519H3.66179L3.22058 23.1003Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffRooms);
export default __webpack_public_path__ + "static/media/staff-rooms.18af3f9e87197d6b71c06d8bcc0acfaf.svg";
export { ForwardRef as ReactComponent };